import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import HeaderIconButton from "./HeaderIconButton";
const HeaderFavoritesButton = (props) => {
    return _jsx(HeaderIconButton, { ...props });
};
export default HeaderFavoritesButton;
